export default __webpack_public_path__ + "static/ParklandDedicationAndFee-in-Lieu-0d36ddf8aa4c1df4f7ffb27d9e41bcb9.jpg";